/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * type of Elec Tariff
 */
export type ElecProductType =
  (typeof ElecProductType)[keyof typeof ElecProductType]

export const ElecProductType = {
  Eco7: "Eco7",
  Standard: "Standard",
  TOU: "TOU",
} as const
